"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DuplicatePlugin = void 0;
const BasePlugin_1 = require("./BasePlugin");
class DuplicatePlugin extends BasePlugin_1.BasePlugin {
  // Assumption: we assume list is sorted by start date
  execute(list, _activities, _groups, _conditions, _selected) {
    let occupiedIntervalEnding = Number.MIN_SAFE_INTEGER;
    for (const activity of list) {
      // If `overlap_registration` is enabled, activities that overlap with the current activity
      // (or any other overlapping activity) will not be disabled.
      if (activity.overlap_registration) {
        continue;
      }
      if (activity.disabled === false && activity.start.getTime() <= occupiedIntervalEnding) {
        // overlapping with one of the already selected
        activity.disabled = true;
      }
      if (activity.registered) {
        // since activities are sorted by start time,
        // we know that NO activity ahead in list is starting before
        // current activity's start time so if we want to check overlapping with
        // any activity ahead we will only require end time of this activity
        occupiedIntervalEnding = Math.max(activity.end.getTime(), occupiedIntervalEnding);
      }
    }
    let occupiedIntervalStarting = Number.MAX_SAFE_INTEGER;
    for (let i = list.length - 1; i >= 0; i--) {
      const activity = list[i];
      // If `overlap_registration` is enabled, activities that overlap with the current activity
      // (or any other overlapping activity) will not be disabled.
      if (activity.overlap_registration) {
        continue;
      }
      if (activity.disabled === false && activity.end.getTime() >= occupiedIntervalStarting) {
        // overlapping with one of the already selected
        activity.disabled = true;
      }
      if (activity.registered) {
        occupiedIntervalStarting = Math.min(activity.start.getTime(), occupiedIntervalStarting);
      }
    }
    return list;
  }
}
exports.DuplicatePlugin = DuplicatePlugin;
